import { useNavigationEventBus as t } from "@ado/acs-standard-library";
const i = "scrollbars=no,menubar=no,resizable=0,location=no,screenX=50,screenY=100,width=460,height=700", r = "unique";
function c(e, n) {
  const o = e.replace("<deptid>", "3");
  (n ?? t()).navigate(
    o,
    r,
    i
  );
}
export {
  c as launchLiveHelp
};
//# sourceMappingURL=index.js.map
